<mat-form-field
  appearance="outline"
  class="w-100 select_h_42"
  [ngClass]="{ multiSelectFilterField: isFilter }"
>
  <mat-label>{{ label }}</mat-label>
  <mat-select
    [value]="value"
    multiple
    (selectionChange)="onSelectionChange($event)"
  >
    <mat-option
      *ngFor="let option of options"
      [value]="option.value"
      [disabled]="option.disabled || isOptionDisabled(option.value)"
    >
      {{ option.label }}
    </mat-option>
  </mat-select>
</mat-form-field>
